export default __webpack_public_path__ + "static/media/button-mini-open.9aeda4a3.svg";